import React, { useState, useEffect } from 'react';
import './QuotationPublicUploadPage.css';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

const QuotationPublicUploadPage = () => {
  const token = window.location.pathname.split('/').filter(Boolean).pop() || '';
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);
  const [okMsg, setOkMsg] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await fetch(`${API_BASE}/quotations/public-upload/${encodeURIComponent(token)}`);
        const j = await r.json();
        if (!r.ok) throw new Error(j.message || 'Enlace no válido');
        if (!cancelled) setInfo(j);
      } catch (e) {
        if (!cancelled) setErr(e.message || 'Error');
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [token]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr(null);
    setOkMsg(null);
    const fd = new FormData(e.target);
    const file = fd.get('file');
    if (!file || !file.size) {
      setErr('Selecciona un archivo');
      return;
    }
    setBusy(true);
    try {
      const up = new FormData();
      up.append('file', file);
      const r = await fetch(`${API_BASE}/quotations/public-upload/${encodeURIComponent(token)}`, {
        method: 'POST',
        body: up
      });
      const j = await r.json();
      if (!r.ok) throw new Error(j.message || 'No se pudo subir');
      setOkMsg('Archivo recibido. Gracias.');
      e.target.reset();
    } catch (e2) {
      setErr(e2.message || 'Error');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="q-upload-page">
      <div className="q-upload-card">
        <h1>Adjuntos — Javiland</h1>
        {err && <p className="q-upload-err">{err}</p>}
        {okMsg && <p className="q-upload-ok">{okMsg}</p>}
        {!info && !err && <p>Cargando…</p>}
        {info && info.success && (
          <>
            <p className="q-upload-lead">
              Cotización <strong>{info.public_number}</strong>
              {info.project_title ? ` — ${info.project_title}` : ''}
            </p>
            <p className="q-upload-meta">
              Tamaño máximo: {(info.max_bytes / 1048576).toFixed(1)} MB · enlace válido hasta {info.expires_at}
            </p>
            <form onSubmit={onSubmit}>
              <input type="file" name="file" required />
              <button type="submit" disabled={busy}>{busy ? 'Subiendo…' : 'Subir archivo'}</button>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default QuotationPublicUploadPage;
